/** Compatibility boundary for project-scoped persistence and conversation identity. */
import { isTauri } from "@/lib/is-tauri";

export const CLIENT_PROTOCOL = "project-scope-v1";
export const CLIENT_PROTOCOL_HEADERS = { "X-Denker-Protocol": CLIENT_PROTOCOL };
/**
 * Headers for frame creates and updates. The web app declares that it reads
 * every Doc content shape: the backend refuses Doc content writes from a web
 * tab without it (`apps/spaces/doc_client_gate.py`), so a tab loaded before
 * the Doc reader cannot overwrite a Doc. The desktop app is gated by its
 * install's version instead and sends nothing (a cross-origin header would
 * need a CORS allowance first).
 */
export function docReaderHeaders(): Record<string, string> {
  return isTauri() ? {} : { "X-Denker-Doc-Reader": "content" };
}

export function withClientProtocol(url: string): string {
  const target = new URL(url);
  target.searchParams.set("denker_protocol", CLIENT_PROTOCOL);
  return target.toString();
}
